module.exports = __webpack_public_path__ + "img/internal-server-error.ea6218c8.svg";